
//Mappings to pages
export enum PageTypePath {
    Home = "/",

    //Administration
    ForgotSigningPassword = "glemt-signaturpassord",

    //registration
    RegistrationForm = "ny-innmelding",
    RegistrationList = "innmeldinger",

    //Sales notes
    SalesNotesList = "sluttsedler",
    SalesNoteItemList = "sluttseddelliste",
    SalesNoteForm = "rediger_sluttseddel",

    //Landing notes
    LandingNoteList = "landingssedler",
    LandingNoteForm = "rediger_landingssedler",
    LandingNoteJournal = "landingsjournal",
    LandingNoteJournalList = "Landingsseddelliste",
      
    // Accounting
    AccountingSettlement = "avregninger",
    AccountingAnnualReport = "aarsrapport",
    AccountStatement = "kontoutskrift",
    //AccountingQuota = "kvote",
    AccountingInvoice = "fakturaer",
    ReleasedPackages = "frigitte-pakker",
    PackagesNotReleased = "baandlagte-pakker",

    //AccountingInterestNote = "rentenotaer",
    //AccountingBuyerBalance = "kjoepersaldo",

    //sales
    //MySalesStatistics = "Min_statistikk",

    //My purchase
    PurchaseOverview = "kjopsoversikt",
    SalesConfirmations = "salgsbekreftelser",
    SalesContract = "salgskontrakter",
    PickList = "Plukkliste",
    PurchaseStatistic = "Innkjøpsstatistikk",

    FreshSales = "Solgt_fersk",
    FrozenSales = "Frossen_Salg",
    FrozenSalesWeekly = "Solgt_frossen_uke",
    SalesStatistics = "Salgsstatistikk",
    OpenStatistics = "aapen-salgsstatistikk",
    StoreStatistics = "Lagerstatistikk",
    AuctionedWeight = "kvantum-auksjonsplikt",

    SalesNoteJournal = "sluttseddeljournal",
    UserProfiles = "profil",
    Users = "brukere",
    UserInformation = "bruker-informasjon",
    NewUser = "ny-bruker",
    OldUsers = "tidligere-brukere",

    UserAgreement = "brukeravtale",
    NewAgreementUsers = "nye-brukeravtaler",
    QuotaTransactions = "kvotetransaksjoner",
    RegistrationOverview = "innmeldingsoversikt",
    FisheryDepartmentLandingNotes = "innmelding-landingssedler",
    FisheryDepartmentSalesNotes = "innmelding-sluttsedler",
    
    //Pdf
    Pdf = "pdf",
    Signature = "signatur",

    AccessDenied = "access-denied",

    Logout = "Logout",
}


const PAGES_WITHOUT_MENU: PageTypePath[] = [
    // PageTypePath.UserProfiles,
    // PageTypePath.Pdf,
    // PageTypePath.UserInformation,
    // PageTypePath.LandingNoteForm,
];

export { PAGES_WITHOUT_MENU };